<template>
    <table :key="displayedSubjects.length">
        <tr class="subjects-row">
            <th></th>
            <th></th>
            <subjects-titles
                :subjects="displayedSubjects"
                :minNumberOfDisplayedSubjects="minNumberOfDisplayedSubjects"
            />
        </tr>
        <tr class="header-row">
            <th>
                <panorama-header-item
                    title="Conventions collectives"
                    toolTip="Conventions collectives tooltip"
                />
            </th>
            <th>
                <panorama-header-item
                    title="NAF"
                    toolTip="NAF tooltip open see more to open apenafs with labels"
                />
            </th>
            <subjects-headers :subjects="displayedSubjects" />
        </tr>
        <panorama-loading-row :subjects="displayedSubjects" />
    </table>
</template>

<script>
import SubjectsTitles from "./result-display/SubjectsTitles.vue";
import SubjectsHeaders from "./result-display/SubjectsHeaders.vue";
import PanoramaHeaderItem from "./PanoramaHeaderItem.vue";
import PanoramaLoadingRow from "./PanoramaLoadingRow.vue";

export default {
    components: {
        SubjectsTitles,
        SubjectsHeaders,
        PanoramaHeaderItem,
        PanoramaLoadingRow,
    },
    props: ["displayedSubjects", "minNumberOfDisplayedSubjects"],
};
</script>

<style scoped lang="sass">
$header-height: 59px
$subject-row-height: 65px

.panorama-container
    position: relative

table
    border-collapse: collapse
    transition: transform 0.1s ease-in-out

    ::v-deep tr
        &.header-row
            th
                background: $color-background
                position: sticky
                top: $header-height + $subject-row-height
                z-index: 2
        &.subjects-row
            th
                background: $color-white
                position: sticky
                top: $header-height
                z-index: 2
        th
            margin: 10px
            min-width: 250px
            height: 40px
            &:nth-child(1)
                width: 250px
</style>
